import {Component, Input} from '@angular/core';

import {ExampleSJ, Word} from '../../models/word.model';
import {LayoutMgrService} from "../../services/layout-mgr/layout-mgr.service";
import {CordovaService} from "../../services/cordova/cordova.service";

@Component({
  selector: 'app-word-example-btn',
  template: `
    <a class="example-btn"
       (click)="openPopup($event)"></a>
  `,
  styleUrls: ['./word-example-btn.component.scss'],
})
export class WordExampleBtnComponent {
  @Input() public word: Word | null = null;
  @Input() public exampleSJ: ExampleSJ | null = null;

  public get cordova(): any {
    return this.cordovaSvc.cordova;
  }

  constructor(
    public lm: LayoutMgrService,
    private cordovaSvc: CordovaService
  ) {
  }

  public openPopup($event: Event): void {
    console.log('app-word-example-btn openPopup() click', this.exampleSJ);
    $event.preventDefault();
    $event.stopPropagation();

    this.lm.OpenExamplePopup(this.word, this.exampleSJ);
  }
}
